import { eventEmitter } from "@/utils/event-emitter.js";
import { templateChange } from "./templateChange.js";
import { appState } from "@/utils/state.js";
import { config } from "@/utils/config.js";
import { templateSelect } from "@/components/main/levelBar/templateSelect.js";

export function levelChange() {
  templateChange();
  eventEmitter.on("levelChange", (index) => {
    if (index) {
      appState.setState("levelInd", Number(index));
    }
    document.querySelector(".level").value = appState.getState("levelInd");
    appState.setState(
      "level",
      config.levels[appState.getState("levelInd")].text
    );
    templateSelect();
    eventEmitter.emit("templateChange", 0);
  });
}
